module.exports = __webpack_public_path__ + "img/logo.bc6f04b6.png";